<header class="public-header">
  <div class="header-shell">
    <a class="brand" href="/" (click)="goHome($event)" aria-label="SALOONS — Accueil">
      SAL<span>OO</span>NS
    </a>

    <nav class="desktop-nav" aria-label="Navigation principale">
      <a href="/" (click)="goHome($event)">Accueil</a>
      <a href="/#how-it-works" (click)="goToSection($event, 'how-it-works')">Le concept</a>
      <a href="/#partners" (click)="goToSection($event, 'partners')">Partenaires</a>
      <a routerLink="/contact">Contact</a>
    </nav>

    <a class="download-cta" routerLink="/download">
      <span>Télécharger</span>
      <svg viewBox="0 0 20 20" aria-hidden="true">
        <path d="M10 3v9m0 0 3.5-3.5M10 12 6.5 8.5M4 15.5h12" />
      </svg>
    </a>

    <button
      class="menu-button"
      type="button"
      aria-label="Ouvrir le menu"
      [attr.aria-expanded]="menuOpen"
      (click)="menuOpen = !menuOpen"
    >
      <span></span><span></span><span></span>
    </button>
  </div>

  @if (menuOpen) {
  <nav class="mobile-nav" aria-label="Navigation mobile">
    <a href="/" (click)="goHome($event)">Accueil</a>
    <a href="/#how-it-works" (click)="goToSection($event, 'how-it-works')">Le concept</a>
    <a href="/#partners" (click)="goToSection($event, 'partners')">Partenaires</a>
    <a routerLink="/contact" (click)="closeMenu()">Contact</a>
    <a class="mobile-download" routerLink="/download" (click)="closeMenu()">Télécharger l'app</a>
  </nav>
  }
</header>
